import React, { useEffect, useState } from "react";
import InboxTable from './InboxTable'
import { OBPSService } from '../../../../../../../libraries/src/services/elements/OBPS';
import { Loader } from "@egovernments/digit-ui-react-components";


function ApplicationDetail() {
    const tenantId = Digit.ULBService.getCurrentTenantId();
    const [apiData, setApiData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async (params) => {
        try {
            const result = await OBPSService.scrutinyReportFailedData(params);
            setApiData(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(async () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed, so add 1
        const day = String(today.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        await fetchData(formattedDate)
    }, [])
    return (
        <div>
            {isLoading &&
                <div>
                    <Loader />
                </div>}
            {!isLoading && apiData && <InboxTable apiData={apiData} />}
        </div>
    )
}

export default ApplicationDetail